module.exports = __webpack_public_path__ + "adf3986ae2581c77421d7e01a8bb72b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-book-reviews.png
// module id = 1112
// module chunks = 0